import { render, staticRenderFns } from "./tkCard.vue?vue&type=template&id=4ec919a4&scoped=true&"
import script from "./tkCard.vue?vue&type=script&lang=js&"
export * from "./tkCard.vue?vue&type=script&lang=js&"
import style0 from "./tkCard.vue?vue&type=style&index=0&id=4ec919a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec919a4",
  null
  
)

export default component.exports